import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'app-bp-mui-input',
  templateUrl: './bp-mui-input.component.html',
  styleUrls: ['./bp-mui-input.component.scss']
})
export class BpMuiInputComponent implements OnInit {

  /**
   * Property to decide the type of input
   */
  @Input() public type = 'name';

  @Input() public disabled = false;

  /**
   * Property to decide the required input
   */
  @Input() public required = false;

  @Input() public name = 'name';

  /**
   * Property to handle change event on input
   */
  @Output() inputChange = new EventEmitter<any>();

  /**
   * Property to handle key up event on input
   */
  @Output() keyupEvent = new EventEmitter<any>();

  /**
   * Property to hold the placeholder
   */
  @Input() public placeholder = '';

  /**
   * Property to display label
   */
  @Input() public showLabel = true;

  /**
   * Property to hold label text
   */
  @Input() labelText = 'Name';

  /**
   * Property to bind value to input
   */
  @Input() public value = '';

  /**
   * Property to hold counter max value
   */
  @Input() public maxLength = 4096;

  errorMessage = '';

  @Input() minLength = 0;

  @Input() isTransparent = true;

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Property to emit on value change event
   */
  public inputValueHandler(event: Event) {
    this.inputChange.emit(event);
  }

  public inputKeyEventHandler(event: Event) {
    this.keyupEvent.emit(event);
  }

}
